/**
 * 回放有效期公共处理逻辑
 */
import { useMsgServer } from 'middle-domain';
import { convertTimeZone, getCurrentTimeZoneOffset } from '@/app-shared/utils/date';

export default {
  data() {
    return {
      recordWatchExpireObj: {}
    };
  },
  computed: {
    permissionValueObj() {
      return this.$domainStore.state.roomBaseServer.permissionValueObj;
    },
    // 服务器返回的当前时区客户端时间
    systemTime() {
      return this.$domainStore.state.roomBaseServer?.watchInitData?.system_time || '';
    }
  },
  created() {
    this.initRecordWatchExpireObj();
    this.listenRecordWatchExpireSetMsg();
  },
  methods: {
    initRecordWatchExpireObj() {
      if (this.permissionValueObj?.record_watch_expire) {
        try {
          this.recordWatchExpireObj = JSON.parse(this.permissionValueObj.record_watch_expire);
        } catch (e) {
          console.error('initRecordWatchExpireObj:', e);
        }
      }
    },
    /**
     * 回放 校验 【功能配置】==>【回放有效期配置】
     */
    checkPlaybackExpiredDateTime() {
      const record_watch_expire = this.recordWatchExpireObj;
      if (
        (this.webinarType === 5 || this.webinarType === 4) &&
        record_watch_expire?.status + '' === '1' // 回放有效期开关 1: 开启  0: 关闭
      ) {
        // {
        //   "status": this.playbackExpirationDateObj.status, //回放有效期开关 1: 开启  0: 关闭
        //   "type": this.playbackExpirationDateObj.type, //类型：1.全天，2.部分时段
        //   "start_date": "",//开始日期 2024-06-10 00:00:00  type=1时此项必填，格式为 yyyy-MM-dd HH:mm:ss；type=2时此项非必填，格式为 yyyy-MM-dd
        //   "end_date": "",//结束日期 2024-06-28 23:59:59  同上
        //   "start_time": "",//开始时间 08:10:00  type=2时此项必填，type=1时不接收此值
        //   "end_time": ""//结束时间 09:10:00  同上
        // }

        if (record_watch_expire?.type + '' === '1') {
          // 全天时段
          if (record_watch_expire?.start_date && record_watch_expire?.end_date) {
            const currentDate = new Date(window.vh_dep_client_date_time);
            const start_date = new Date(record_watch_expire?.start_date.replace(/-/g, '/'));
            const end_date = new Date(record_watch_expire?.end_date.replace(/-/g, '/'));

            if (
              !(
                currentDate.getTime() >= start_date.getTime() &&
                currentDate.getTime() <= end_date.getTime()
              )
            ) {
              console.log(
                '全天时段 currentDate 不在 start_date 和 end_date 范围内  currentDate:' +
                  currentDate,
                ' start_date:' + start_date + ' end_date:' + end_date
              );
              return false;
            } else {
              console.log('全天时段 currentDate 在 start_date 和 end_date 范围内');
            }
          } else {
            // 未配置开始日期和结束日期，不做有效期校验
            return true;
          }
        } else if (record_watch_expire?.type + '' === '2') {
          // 部分时段
          if (record_watch_expire?.start_time && record_watch_expire?.end_time) {
            if (record_watch_expire?.start_date && record_watch_expire?.end_date) {
              // 部分时段，配置了 开始日期、结束日期、开始时间、结束时间
              const currentDate = new Date(window.vh_dep_client_date_time);
              const newStartDate =
                record_watch_expire?.start_date.split(' ')[0] +
                ' ' +
                record_watch_expire?.start_time;
              const start_date = new Date(newStartDate.replace(/-/g, '/'));
              const newEndDate =
                record_watch_expire?.end_date.split(' ')[0] + ' ' + record_watch_expire?.end_time;
              const end_date = new Date(newEndDate.replace(/-/g, '/'));

              if (
                !(
                  currentDate.getTime() >= start_date.getTime() &&
                  currentDate.getTime() <= end_date.getTime()
                )
              ) {
                console.log(
                  '部分时段 currentDate 不在 start_date 和 end_date 范围内 currentDate:' +
                    currentDate,
                  ' start_date:' + start_date + ' end_date:' + end_date
                );
                return false;
              } else {
                console.log('部分时段 currentDate 在 start_date 和 end_date 范围内');
              }
            }
            // 部分时段，仅配置了 开始时间、结束时间

            const currentDate = new Date(window.vh_dep_client_date_time);
            let year = currentDate.getFullYear();
            let month = currentDate.getMonth() + 1;
            let date = currentDate.getDate();

            const newStartDate =
              year + '-' + month + '-' + date + ' ' + record_watch_expire?.start_time;
            const start_date = new Date(newStartDate.replace(/-/g, '/'));
            const newEndDate =
              year + '-' + month + '-' + date + ' ' + record_watch_expire?.end_time;
            const end_date = new Date(newEndDate.replace(/-/g, '/'));

            if (
              !(
                currentDate.getTime() >= start_date.getTime() &&
                currentDate.getTime() <= end_date.getTime()
              )
            ) {
              console.log(
                '部分时段，仅配置了 开始时间、结束时间 currentDate 不在 start_date 和 end_date 范围内   currentDate:' +
                  currentDate,
                ' start_date:' + start_date + ' end_date:' + end_date
              );
              return false;
            } else {
              console.log(
                '部分时段，仅配置了 开始时间、结束时间 currentDate 在 start_date 和 end_date 范围内'
              );
            }
          }
        }
      }

      return true;
    },
    /**
     * 根据服务器返回的当前时区客户端时间，进行计时，避免用户手动修改客户端时间
     */
    handleVhDepClientDateTime() {
      let _self = this;
      /**
       * 当前是回放，已开通 回放有效期校验
       * @type {Date}
       */
      const record_watch_expire = _self.recordWatchExpireObj;
      if (
        (_self.webinarType === 5 || _self.webinarType === 4) &&
        record_watch_expire?.status + '' === '1' // 回放有效期开关 1: 开启  0: 关闭
      ) {
        const currentZoneSystemTime =
          _self.recordWatchExpireObj?.currentZoneSystemTime || _self.systemTime || null;
        window.vh_dep_client_date_time = new Date(dayjs(currentZoneSystemTime).unix() * 1000); // 优先级：消息返回服务器时间 > 页面加载返回的服务器时间 > 当前客户端时间

        // 使用setInterval每秒调用incrementTime函数
        _self.vh_dep_client_date_time_intervalId = setInterval(function () {
          // 使用Date对象的setSeconds方法来增加一秒
          window.vh_dep_client_date_time.setSeconds(
            window.vh_dep_client_date_time.getSeconds() + 1
          );
          if (_self.isPlaying && !_self.checkPlaybackExpiredDateTime()) {
            _self.pause();
            _self.showPlaybackExpiredMsg();
            _self.clearVhDepClientDateTimeInternalTask();
            console.log('handleVhDepClientDateTime end');
          }
          // 打印更新后的时间
          console.log(
            'handleVhDepClientDateTime vh_dep_client_date_time: ',
            window.vh_dep_client_date_time.toLocaleTimeString()
          );
        }, 1000);
      }
    },
    clearVhDepClientDateTimeInternalTask() {
      if (this.vh_dep_client_date_time_intervalId) {
        clearInterval(this.vh_dep_client_date_time_intervalId);
        this.vh_dep_client_date_time_intervalId = null;
      }
    },
    listenRecordWatchExpireSetMsg() {
      const msgServer = useMsgServer();
      msgServer.$onMsg('ROOM_MSG', msg => {
        if (msg?.data?.type === 'record_watch_expire_set') {
          this.recordWatchExpireObj = {
            status: msg?.data?.msg_data.status, //回放有效期开关 1: 开启  0: 关闭
            type: msg?.data?.msg_data.type, //类型：1.全天，2.部分时段
            start_date: msg?.data?.msg_data.start_date || '', //开始日期 2024-06-10 00:00:00  type=1时此项必填，格式为 yyyy-MM-dd HH:mm:ss；type=2时此项非必填，格式为 yyyy-MM-dd
            end_date: msg?.data?.msg_data.end_date || '', //结束日期 2024-06-28 23:59:59  同上
            start_time: msg?.data?.msg_data.start_time || '', //开始时间 08:10:00  type=2时此项必填，type=1时不接收此值
            end_time: msg?.data?.msg_data.end_time || '' //结束时间 09:10:00  同上
          };
          console.log(
            'record_watch_expire_set recordWatchExpireObj:',
            this.recordWatchExpireObj,
            msg?.data
          );

          if (this.recordWatchExpireObj.status + '' === '1') {
            if (msg?.data?.msg_data.system_time) {
              const bjSysT = msg?.data?.msg_data.system_time || null; // 消息返回的是 当前服务器北京时间
              // 将北京时间转换成当前时区时间
              const currentZoneOffset = getCurrentTimeZoneOffset();
              const currentZoneSystemTime = convertTimeZone(
                dayjs(bjSysT).unix() * 1000,
                8,
                currentZoneOffset
              );
              this.recordWatchExpireObj.currentZoneSystemTime = currentZoneSystemTime;
            }
            console.log('record_watch_expire_set recordWatchExpireObj:', this.recordWatchExpireObj);
            this.clearVhDepClientDateTimeInternalTask();
            this.handleVhDepClientDateTime();
          } else {
            this.clearVhDepClientDateTimeInternalTask();
          }
        }
      });
    }
  }
};
